if (!Object.hasOwn) {
  Object.hasOwn = Object.prototype.hasOwnProperty;
}
